import CardHeader from "@material-ui/core/CardHeader";
import { withStyles } from "@material-ui/core/styles";
import React from "react";

const styles = {
  root: {
    height: "90px !important",
    maxHeight: "90px !important",
    minHeight: "90px !important",
    paddingTop: "0 !important",
    paddingRight: "0 !important",
    paddingBottom: "0 !important",
    paddingLeft: "0 !important",
    padding: "0 !important",
    margin: "0 !important",
  },
  title: {
    padding: "26px 24px 25px 24px !important",
    margin: "0 !important",
    fontSize: "34px",
    fontWeight: "400",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "40px",
    letterSpacing: "0.25px",
    textAlign: "left",
    color: "#37474f",
  },
  action: {
    margin: "0 !important",
    padding: "26px 24px 25px 24px",
  },
  withImageRoot: {
    height: "108px !important",
    maxHeight: "108px !important",
    minHeight: "90px !important",
    paddingTop: "0 !important",
    paddingRight: "0 !important",
    paddingBottom: "0 !important",
    paddingLeft: "0 !important",
    padding: "0 !important",
    margin: "0 !important",
  },
  avatar: {
    order: "1",
    display: "flex",
    justifyContent: "flex-end",
    maxWidth: "40%",
  },
};

function PageCardHeader(props) {
  return (
    <CardHeader
      classes={({
        root: props.withImageCardHeader
          ? props.classes.withImageRoot
          : props.classes.root,
        title: props.classes.title,
        action: props.classes.action,
        avatar: props.withImageCardHeader ? props.classes.avatar : "",
        ...props.overloadedClasses || {}
      })}
      style={styles}
      title={props.title}
      action={props.action}
      titleTypographyProps={props.titleTypographyProps}
      avatar={props.avatar}
    />
  );
}

export default withStyles(styles)(PageCardHeader);
